export const censusLookupCopy = {
  pt: {
    title: "Consulta Censitária",
    subtitle:
      "Consulte setores censitários, resumos municipais e variáveis do IBGE 2022 com base na camada nacional de inteligência censitária da Incorporalink.",
    kicker: "IBGE 2022 · National foundation layer",
    safety:
      "Esta consulta utiliza dados censitários estruturados e não representa recomendação de investimento, avaliação imobiliária, score de oportunidade ou análise de risco. As geometrias permanecem separadas e não são carregadas nesta tela.",
    tabs: {
      municipality: "Resumo municipal",
      sector: "Setor censitário",
      variables: "Dicionário de variáveis",
    },
  },
  en: {
    title: "Census Intelligence Lookup",
    subtitle:
      "Explore census sectors, municipal summaries and IBGE 2022 variables from Incorporalink's national census intelligence layer.",
    kicker: "IBGE 2022 · National foundation layer",
    safety:
      "This lookup uses structured census data and does not represent an investment recommendation, property valuation, opportunity score or risk analysis. Geometries remain separate and are not loaded in this view.",
    tabs: {
      municipality: "Municipal summary",
      sector: "Census sector",
      variables: "Variable dictionary",
    },
  },
};
